module.exports = "<ul class=\"ot-link-list\">\n  <li ng-repeat=\"link in vm.linkList | link:vm.session\">\n    <a ng-show=\"link.label == 'LANDING.POWERED'\" ng-href=\"http://onetable.org\" ng-class=\"computeLinkCss()\" class=\"custom-powered\" target=\"_blank\">Powered by</a>\n    <ot-link ng-show=\"link.label != 'LANDING.POWERED'\" item=\"link\"></ot-link>\n  </li>\n</ul>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/linkList.html
 ** module id = 289
 ** module chunks = 1
 **/